import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../constants';

const useToggleClausesCounts = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ queryUUID, dictionaryCode }) => handler({
    type: actions.TOGGLE_CLAUSES_COUNTS, category, code, queryUUID, dictionaryCode,
  }), [category, code]);
};

const useToggleClauseCounts = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ queryUUID, clauseUUID }) => handler({
    type: actions.TOGGLE_CLAUSE_COUNTS, category, code, queryUUID, clauseUUID,
  }), [category, code]);
};

export default {
  useToggleClauseCounts,
  useToggleClausesCounts,
};
